<template>
<div class="content2">
  <SelectCdjProjectHeader @onHeader="onHeader">
    <el-date-picker
      style="width: 150px"
      size="mini"
      v-model="reginWhere.year_month"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="月份" @change="pageChange(1)">
    </el-date-picker>
    <el-button size="mini" @click="exportExcel" type="primary" >导出报表</el-button>
  </SelectCdjProjectHeader>

  <div class="table-wrap">
    <el-table
      v-loading="loading"
      v-if="pageData" :data="pageData.list"
      border
      style="width: 100%" height="70vh">
      <el-table-column
        align="center"
        prop="zq_region_name"
        label="战区"
        width="120" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        prop="pq_region_name"
        label="片区"
        width="120" fixed>
      </el-table-column>
      <el-table-column
        align="center"
        prop="project_name"
        label="项目名称"
        width="200" fixed>
      </el-table-column>

      <el-table-column
        align="center"
        label="1至2年欠费状况">
        <el-table-column
          align="center"
          prop="year_1_2_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_1_2_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="两年以上欠费状况">
        <el-table-column
          align="center"
          prop="year_2_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_2_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="一年以上欠费总额">
        <el-table-column
          align="center"
          prop="year_1_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_1_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="年度诉讼计划">
        <el-table-column
          align="center"
          prop="year_ss_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_ss_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>
      <el-table-column
        align="center"
        label="诉讼比例">
        <el-table-column
          align="center"
          prop="year_ss_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="year_ss_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        :label="`${selectMonthValue}月计划（户数）`">
        <el-table-column
          align="center"
          prop="current_jh_tj"
          label="提交"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="current_jh_st"
          label="诉调"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="current_jh_la"
          label="立案"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="current_jh_xj"
          label="小计"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        :label="`${selectMonthValue}月实际（户数）`">
        <el-table-column
          align="center"
          prop="current_sj_tj"
          label="提交"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="current_sj_st"
          label="诉调"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="current_sj_la"
          label="立案"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="current_sj_xj"
          label="小计"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="current_sj_la_rate"
          label="立案率"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="当月回款">
        <el-table-column
          align="center"
          prop="current_sj_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="current_sj_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        :label="`1-${selectMonthValue}月计划（户数）`">
        <el-table-column
          align="center"
          prop="accumulate_jh_tj"
          label="提交"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="accumulate_jh_st"
          label="诉调"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="accumulate_jh_la"
          label="立案"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="accumulate_jh_xj"
          label="小计"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        :label="`1-${selectMonthValue}月实际（户数）`">
        <el-table-column
          align="center"
          prop="accumulate_sj_tj"
          label="提交"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="accumulate_sj_st"
          label="诉调"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="accumulate_sj_la"
          label="立案"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="accumulate_sj_xj"
          label="小计"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="accumulate_sj_la_rate"
          label="立案率"
          width="100">
        </el-table-column>
      </el-table-column>

      <el-table-column
        align="center"
        label="累计回款">
        <el-table-column
          align="center"
          prop="accumulate_sj_count"
          label="户数"
          width="100">
        </el-table-column>
        <el-table-column
          align="center"
          prop="accumulate_sj_money"
          label="金额"
          width="100">
        </el-table-column>
      </el-table-column>


    </el-table>
  </div>
  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                   :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                   @current-change="pageChange"></el-pagination>
  </div>
</div>
</template>

<script>
import SelectCdjProjectHeader from "../common/SelectCdjProjectHeader";
import {CommonHelp} from "../../common/CommonHelp";
import moment from "moment";
import ButlerHttp from "../../common/ButlerHttp";
export default {
  name: "CaseFilingRateAndPaymentCollectionStatistics",
  components: {SelectCdjProjectHeader},
  data(){
    return{
      loading: false,
      reginWhere:{
        year_month:""
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      selectMonthValue:moment().format("M"),
    }
  },
  mounted() {
    const that=this;
  },
  methods:{
    onHeader(e){
      this.reginWhere={
        ...this.reginWhere,
        ...e
      };
      this.pageChange(1)
    },
    getList() {
      const that = this;
      that.loading = true;
      let where = {}
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.year_month) where.year_month=that.reginWhere.year_month;
      ButlerHttp.post("LegalStatistics/立案率及回款统计列表", {
        ...where,
        page: that.pageData.page,
        page_size: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.pageData = res.data;
        }
        that.loading = false;
      });
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i
      CommonHelp.debounce(function () {
        that.getList();
      },500,that);

    },
    exportExcel() {
      const that = this;
      that.loading = true;
      let where = {}
      if(that.reginWhere.project_region) where.region_id=that.reginWhere.project_region;
      if(that.reginWhere.project_name) where.project_id=that.reginWhere.project_name;
      if(that.reginWhere.project_ids&&that.reginWhere.project_ids.length) where.project_ids=that.reginWhere.project_ids;
      if(that.reginWhere.year_month) where.year_month=that.reginWhere.year_month;
      ButlerHttp.post("LegalStatistics/立案率及回款统计表", {
        ...where
      }, res => {
        if (res.code) {
          window.open(res.data);
        }
        that.loading = false;
      });
    },
    round(val,num=2) {
      return Math.round(val*100)/100
    }
  },
  watch:{
    "reginWhere.year_month":function(n,o){
      this.selectMonthValue=moment(n).format("M");
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.content2{
  background-color: #ffffff;
  //width: 100%;
  margin: 20px;
  .header{
    padding-top: 5px;
    padding-bottom: 10px;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: #FFFFFF;
  }
  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: flex;
    flex-direction: row;

    .header-tip-body{
      //width: 500px;
      margin-left: 50px;
      display: flex;
      flex-direction: row;
      //justify-content: space-between;
      .header-tip-body-item{
        margin-left: 50px;
        display: flex;
        flex-direction: row;
      }
    }
  }
  .pagination-wrap{
    margin-top: 10px;
    text-align: center;
  }

  >>>.el-table--border, .el-table--group{
    border: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border .el-table__cell, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
    border-right: 1px solid #000000;
  }
  >>>.el-table td.el-table__cell, .el-table th.el-table__cell.is-leaf{
    border-bottom: 1px solid #000000;
  }
  >>>.el-table--border th.el-table__cell, .el-table__fixed-right-patch{
    border-bottom: 1px solid #000000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/litigation/CaseFilingRateAndPaymentCollectionStatistics.vue